import { render, staticRenderFns } from "./g-field.vue?vue&type=template&id=8c11ad7a&scoped=true"
import script from "./g-field.vue?vue&type=script&lang=js"
export * from "./g-field.vue?vue&type=script&lang=js"
import style0 from "./g-field.vue?vue&type=style&index=0&id=8c11ad7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c11ad7a",
  null
  
)

export default component.exports